import { deleteAsync, deleteJsonWithStatusAsync, getJsonAsync, postFileAsync, postJsonAsync, putJsonAsync } from './fetch';

export type EndpointHandler<TResult> = (urlParams: object, bodyParams: object) => Promise<TResult>;
export type EndpointFileHandler<TResult> = (urlParams: object, fileContent: string) => Promise<TResult>;

export type CallResultResponse<TResult> = {text: string, json: TResult}
export type CallResult<TResult> = {status: number, response: CallResultResponse<TResult>}

export type ControllerDefinition<TControllerEndpoints> = {
    [index in keyof TControllerEndpoints]: TControllerEndpoints[index] extends (basePath: string) => infer Return ? Return : void
}

/**
 * 
 * @param basePath 
 * @param endpoints 
 * @returns 
 */
export function createController<TControllerEndpoints>(basePath: string, endpoints: TControllerEndpoints): ControllerDefinition<TControllerEndpoints> {
    const keys = Object.keys(endpoints);

    const res: any = {};

    for (const k of keys) {
        res[k] = endpoints[k](basePath);
    }

    return res;
}

/**
 * 
 * @param method 
 * @param path 
 * @returns 
 */
export function createControllerEndpoint<TResult>(method: 'GET' | 'POST' | 'PUT' | 'DELETE', path: string): (basePath: string) => EndpointHandler<TResult> {
    return (basePath: string) => createControllerEndpointHandler<TResult>(basePath, method, path);
}

export function createControllerFileEndpoint<TResult>(method: 'POST', path: string): (basePath: string) => EndpointFileHandler<TResult> {
    return (basePath: string) => createControllerFileEndpointHandler<TResult>(basePath, method, path);
}

export function createControllerEndpointWithStatus<TResult>(method: 'GET' | 'POST' | 'PUT' | 'DELETE', path: string): (basePath: string) => EndpointHandler<CallResult<TResult>> {
    return (basePath: string) => createControllerEndpointHandlerWithStatus<TResult>(basePath, method, path);
}

function createControllerEndpointHandler<TResult>(basePath: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', path: string): EndpointHandler<TResult> {
    return (urlParams, bodyParams) => {
        return new Promise((resolve, reject) => {
            if (method == 'GET') {
                getJsonAsync(replaceParams(combinePaths(basePath, path), urlParams)).then(val => resolve(val)).catch(reject);
            } else if (method == 'POST') {
                postJsonAsync(replaceParams(combinePaths(basePath, path), urlParams), bodyParams).then(val => resolve(val)).catch(reject);
            } else if (method == 'PUT') {
                putJsonAsync(replaceParams(combinePaths(basePath, path), urlParams), bodyParams).then(val => resolve(val)).catch(reject);
            } else if (method == 'DELETE') {
                deleteAsync(replaceParams(combinePaths(basePath, path), urlParams)).then(val => resolve(val)).catch(reject);
            }
        })
    };
}

function createControllerFileEndpointHandler<TResult>(basePath: string, method: 'POST', path: string): EndpointFileHandler<TResult> {
    return (urlParams, fileContent) => {
        return new Promise((resolve, reject) => {
            if (method == 'POST') {
                postFileAsync(replaceParams(combinePaths(basePath, path), urlParams), fileContent).then(val => resolve(val)).catch(reject);
            }
        })
    };
}

function createControllerEndpointHandlerWithStatus<TResult>(basePath: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', path: string): EndpointHandler<CallResult<TResult>> {
    return (urlParams, bodyParams) => {
        return new Promise((resolve, reject) => {
            if (method == 'GET') {
                getJsonAsync(replaceParams(combinePaths(basePath, path), urlParams)).then(val => resolve(val)).catch(reject);
            } else if (method == 'POST') {
                postJsonAsync(replaceParams(combinePaths(basePath, path), urlParams), bodyParams).then(val => resolve(val)).catch(reject);
            } else if (method == 'PUT') {
                putJsonAsync(replaceParams(combinePaths(basePath, path), urlParams), bodyParams).then(val => resolve(val)).catch(reject);
            } else if (method == 'DELETE') {
                deleteJsonWithStatusAsync<TResult>(replaceParams(combinePaths(basePath, path), urlParams)).then(val => resolve(val)).catch(reject);
            }
        })
    };
}

function combinePaths(...segments: string[]) {
    return segments.join('');
}

function replaceParams(fullPath: string, urlParams: any) {
    var regExp = /\{([^\}]+)\}/g;
    var matches = fullPath.match(regExp);

    var usedParamsInPath = [];

    for (var i in matches) {
        var paramName = matches[i].substring(1, matches[i].length - 1);
        fullPath = fullPath.replace('{' + paramName + '}', urlParams[paramName] ? urlParams[paramName] : '');
        fullPath = fullPath.replace('//', '/');

        //if (urlParams[paramName]) usedParamsInPath.push(urlParams[paramName]);
        usedParamsInPath.push(paramName);
    }

    function serializeParam(key, paramValue) {
        if (Array.isArray(paramValue)) {
            var path = paramValue[0];
            for (var i = 1; i < paramValue.length; i++) {
                if (paramValue[i]) {
                    path += '&' + key + '=' + encodeURIComponent(paramValue[i]);
                }
            }
            return path;
        } else {
            return encodeURIComponent(paramValue);
        }
    }

    var questMark = false;
    for (var i in urlParams) {
        if (usedParamsInPath.indexOf(i) == -1) {
            if (typeof urlParams[i] !== 'undefined') {
                if (questMark == false) {
                    fullPath += '?';
                    questMark = true;
                } else {
                    fullPath += '&';
                }

                fullPath += i + '=' + serializeParam(i, urlParams[i]);
            }
        }
    }

    return fullPath;
}


// function create(basePath: string, path: string) {
//     var fullPath = basePath + path;
//     var regExp = /\{([^\}]+)\}/g;
//     var matches = fullPath.match(regExp);

//     var usedParamsInPath = [];

//     //urlParams['organizationUri'] = OrganizationUri;

//     for (var i in matches) {
//         var paramName = matches[i].substring(1, matches[i].length - 1);
//         fullPath = fullPath.replace('{' + paramName + '}', urlParams[paramName] ? urlParams[paramName] : '');
//         fullPath = fullPath.replace('//', '/');

//         //if (urlParams[paramName]) usedParamsInPath.push(urlParams[paramName]);
//         usedParamsInPath.push(paramName);
//     }

//     function serializeParam(key, paramValue) {
//         if (Array.isArray(paramValue)) {
//             var path = paramValue[0];
//             for (var i = 1; i < paramValue.length; i++) {
//                 if (paramValue[i]) {
//                     path += '&' + key + '=' + paramValue[i];
//                 }
//             }
//             return path;
//         } else {
//             return paramValue;
//         }
//     }

//     var questMark = false;
//     for (var i in urlParams) {
//         if ($.inArray(i, usedParamsInPath) == -1) {
//             if (typeof urlParams[i] !== 'undefined') {
//                 if (questMark == false) {
//                     fullPath += '?';
//                     questMark = true;
//                 } else {
//                     fullPath += '&';
//                 }

//                 fullPath += i + '=' + serializeParam(i, urlParams[i]);
//             }
//         }
//     }

//     return fullPath;
// }
